import React from 'react';
import './Loader.css';

const DivLoader = () => {
  return (
    <div id="div-loader" className="loader-container">
      <div className="loading-div">
        <div className="dot1"></div>
        <div className="dot2"></div>
        <div className="dot3"></div>
      </div>
    </div>
  );
};

export default DivLoader;